import { Controller } from "@hotwired/stimulus"

// Zoom du Gantt : change la largeur totale du canvas (les barres restent en %
// et s'étirent en conséquence). "Ajuster" = pleine largeur, "Mois"/"Semaine"
// élargissent pour scroller horizontalement.
export default class extends Controller {
  static targets = ["canvas"]

  setZoom(event) {
    const zoom   = event.currentTarget.dataset.zoom
    const widths = { fit: "100%", month: "1600px", week: "3400px" }
    if (this.hasCanvasTarget) {
      this.canvasTarget.style.setProperty("--gantt-width", widths[zoom] || "100%")
    }
    this.element.querySelectorAll(".pa-gantt__zoom button").forEach(b => {
      b.classList.toggle("is-active", b === event.currentTarget)
    })
  }
}
